export enum AppRegions {
  NWA = 'NWA',
  SWA = 'SWA',
  INDY = 'INDY',
  ORV = 'ORV',
  NOIN = 'NOIN',
  CIL = 'CIL',
  COH = 'COH',
  CINCY = 'CINCY',
}
